import React, { useState, useEffect } from "react";
import {
  Avatar,
  Modal,
  Button,
  TextField,
  Grid,
  Typography,
  Paper,
  Select,
  MenuItem,
  Divider,
  FormControlLabel,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ImageCropProfile from "../../../FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../FormDialog/RemoveProfilePic";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import addVendor from "../../../../assets/images/Add User-rafiki.svg";
import useStyles from "./styles";
import { useUserContext } from "../../../../context/UserContext";

export default function AddVendor() {
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const classes = useStyles();
  const { store } = useUserContext();
  const token = store.data.token;
  // // category list retrive from DB

  const [vendorCategories, setVendorCategories] = useState([]);
  const [productCategory, setProductCategories] = useState([]);
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  // image uplaod Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);

  const handleOpen = () => {
    setModelOpen(true);
  };

  const handleClose = () => {
    setModelOpen(false);
  };

  const onSelectlogo = (image) => {
    setLogo(image);
  };

  ///////Show delete ProfilePic dialog//////
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setLogo("");
    setIsProfilePicRemove(false);
  };

  const initialValues = {
    companyName: "",
    email: "",
    businessNumber: "",
    address: "",
    description: "",
    typeOfBusiness: "",
    contactPersonName: "",
    contactPersonDesignation: "",
    contactPersonNumber: "",
    category: "",
    country: "Pakistan",
    city: "Lahore",
  };

  const [logo, setLogo] = useState("");
  const validationSchema = Yup.object().shape({
    companyName: Yup.string().required("Required"),
    email: Yup.string().email("Please enter email").required("Required*"),
    businessNumber: Yup.string()
      .min(11)
      .required("Please Enter The Contact number!!"),
    address: Yup.string().required("Required*"),
    description: Yup.string().required("Please enter a short description"),
    typeOfBusiness: Yup.string().required(
      "Please Enter Your Type Of Business!"
    ),
    contactPersonName: Yup.string().required("Please Enter The Name!!"),
    contactPersonDesignation: Yup.string().required(
      "Please Enter Your Designation!"
    ),
    contactPersonNumber: Yup.string()
      .min(11)
      .required("Please Enter the Contact Number!"),
    category: Yup.string(),
    city: Yup.string().required("required"),
    country: Yup.string().required("required"),
  });

  const onSubmit = (values, props) => {
    console.log("Values are ", values);
    const {
      companyName,
      email,
      businessNumber,
      address,
      description,
      typeOfBusiness,
      contactPersonName,
      contactPersonDesignation,
      contactPersonNumber,
      category,
      country,
      city,
    } = values;
    api
      .post(
        `/admin/vendor`,
        {
          companyName,
          email,
          businessNumber,
          address,
          description,
          typeOfBusiness,
          contactPersonName,
          contactPersonDesignation,
          contactPersonNumber,
          category,
          country,
          city,
          logo,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        console.log(res);
        try {
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Vendor Has Been Added Successfully!!",
            open: true,
          });
        } catch (error) {}
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Please Fill All The Fields First!",
          type: "error",
          open: true,
        });
      });
  };

  const getVendorCategory = async () => {
    // Parent Category
    api
      .get("/admin/vendorCategories", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        const categoryList = res.data.data.categories;
        setVendorCategories(categoryList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  // Retriving List from Categories from API
  useEffect(() => {
    getVendorCategory();
    // eslint-disable-next-line
  }, []);

  return (
    <Grid container component={Paper}>
      <Grid item xs={12} sm={12} md={12}>
        <div className={classes.paper}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Typography variant="h4" gutterBottom>
                Add Vendor Details
              </Typography>
              <Divider />
              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form className={classes.form}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          margin="dense"
                          variant="outlined"
                          required
                          fullWidth
                          label="Company Name"
                          name="companyName"
                          helperText={<ErrorMessage name="companyName" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          margin="dense"
                          variant="outlined"
                          required
                          fullWidth
                          label="Email"
                          name="email"
                          helperText={<ErrorMessage name="email" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          multiline
                          rows={3}
                          name="description"
                          label="Description"
                          helperText={<ErrorMessage name="description" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          multiline
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Address"
                          name="address"
                          rows={3}
                          helperText={<ErrorMessage name="address" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          errors
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Business Number"
                          name="businessNumber"
                          helperText={<ErrorMessage name="businessNumber" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={Select}
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Vendor Category"
                          style={{ marginTop: 8 }}
                          defaultValue={"DEFAULT"}
                          name="category"
                          helperText={<ErrorMessage name="category" />}
                        >
                          <MenuItem value="DEFAULT" disabled>
                            Choose a Vendor Category
                          </MenuItem>
                          {vendorCategories.map((el, index) => (
                            <MenuItem value={el.name} key={index}>
                              {el.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Type Of Bunsiness"
                          name="typeOfBusiness"
                          helperText={<ErrorMessage name="typeOfBusiness" />}
                        />
                      </Grid>
                    </Grid>{" "}
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="Country"
                          name="country"
                          helperText={<ErrorMessage name="country" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          label="City"
                          name="city"
                          helperText={<ErrorMessage name="city" />}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="h4" gutterBottom>
                          Representative Details
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          margin="dense"
                          variant="outlined"
                          required
                          fullWidth
                          label="Representative Name"
                          name="contactPersonName"
                          helperText={<ErrorMessage name="contactPersonName" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          margin="dense"
                          variant="outlined"
                          required
                          fullWidth
                          label="Representative Number"
                          name="contactPersonNumber"
                          helperText={
                            <ErrorMessage name="contactPersonNumber" />
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Field
                          as={TextField}
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          name="contactPersonDesignation"
                          label="Representative Designation"
                          helperText={
                            <ErrorMessage name="contactPersonDesignation" />
                          }
                        />
                      </Grid>
                    </Grid>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 20,
                        marginBottom: 5,
                        padding: 20,
                        height: 160,
                        border: "1px solid #c4c4c4",
                        borderRadius: 6,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          marginBottom: "20px",
                        }}
                      >
                        <Avatar
                          alt="profile photo"
                          src={logo}
                          className={classes.avatarInProfileSetting}
                        >
                          {"Pic HERE"}
                        </Avatar>
                        <div style={{ marginTop: 50, marginLeft: 20 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleOpen}
                          >
                            <AddAPhotoIcon
                              style={{
                                marginRight: 5,
                                fontSize: 22,
                                marginBottom: 5,
                              }}
                            />
                            Upload
                          </Button>
                          <Button
                            onClick={handlerRemoveProfilePic}
                            style={{ color: "red" }}
                          >
                            Remove Image
                          </Button>
                        </div>
                      </div>
                    </div>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                        <Button
                          type="submit"
                          size="large"
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                        >
                          Add Vendor
                        </Button>
                        <RemoveProfilePic
                          RemoveProfilePic={isProfilePicRemove}
                          setRemoveProfilePic={setIsProfilePicRemove}
                          confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                        />
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
            <Grid item xs={false} sm={false} md={false} lg={4}>
              <div
                style={{
                  border: "1px solid rgb(224 224 224)",
                  borderRadius: 6,
                  padding: 15,
                  marginTop: 35,
                }}
              >
                <img
                  src={addVendor}
                  alt="vendor"
                  style={{
                    maxWidth: "300px",
                    marginBottom: 20,
                  }}
                />
                <Typography variant="h5">DO YOU KNOW?</Typography>
                <Typography variant="body2" style={{ textAlign: "justify" }}>
                  In order to make more sales, Write an eye-catching and short
                  name for Vendor and upload its high-quality images.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
        {/* </Container> */}
      </Grid>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClose}
          />
        </div>
      </Modal>
    </Grid>
  );
}
